import React, { Component } from 'react';

import ElementWithPopover from '../../element-with-popover';
import FeesBreakdown from '../../fees-breakdown';

class FeesBreakdownDetails extends Component {
  feesContent() {
    const { feesAmount, costPerSlot, shareAmount, claimedSlots, amount } = this.props;

    return (
      <FeesBreakdown
        amount={amount}
        shareAmount={shareAmount}
        claimedSlots={claimedSlots}
        costPerSlot={costPerSlot}
        feesAmount={feesAmount}
      />
    );
  }

  render() {
    const { feesAmount } = this.props;
    if (feesAmount && feesAmount.amountCents === 0) return null;

    return (
      <ElementWithPopover name="fees-breakdown" className="d-inline-block" content={this.feesContent()}>
        <span className="small-print">
          <i className="fa fa-question round-border small cool-grey" aria-hidden="true" />
        </span>
      </ElementWithPopover>
    );
  }
}

export default FeesBreakdownDetails;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/fees-breakdown-details.js